import React from 'react';
import { Box } from '@mui/material';
import Keygen from '../../components/Keygen/Keygen';

const OnlineKeygen: React.FC = (): React.JSX.Element => {
  return (
    <Box sx={{ p: 3 }}>
      <Keygen />
    </Box>
  );
};

export default OnlineKeygen;
